module.exports = "/static/assets/30a425e0a95db6048c84483c5cced06d.png";